import { MalType } from '../../models';

export interface MalTypeState {
    malTypesCreate: MalType[];
    malTypesDelete: MalType[];
    malTypesExport: MalType[];
}

export const SET_MAL_TYPE = 'SET_MAL_TYPE';

export interface SetMalType {
    type: typeof SET_MAL_TYPE;
    payload: MalTypeState;
}

export type MalTypeActionTypes = SetMalType;